
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import {throwError as observableThrowError,  Observable } from 'rxjs';
import { BaseApi } from './BaseApi';
import * as moment from 'moment';

export class OnboardingApi extends BaseApi {
  endPoint: string = '/api/admin/onboarding';

  public import(body): Observable<any> {
    return this.post(`${this.endPoint}/import`, {}, body);
  }

  public listExtended(limit?: number, offset: number = 0): Observable<any> {
    let dynamicEndPoint = this.endPoint + '/list/extended';
    let _routeParams = {};
    if (limit && limit > 0) {
      _routeParams = {
        limit: limit,
        offset: offset
      };
      dynamicEndPoint += '/limit/:limit/offset/:offset/';
    }
    return this._get(dynamicEndPoint, _routeParams);
  }

  public executeAction(body: {ids: string[]; action: string}): Observable<any> {
    if (!body.ids.length) {
      throw observableThrowError('Cannot update document because no _id was supplied');
    }

    if (!body.action) {
      throw observableThrowError('Cannot update document because action was not supplied');
    }
    const _routeParams: any = {
      action: body.action
    };

    return this.post(`${this.endPoint}/action/:action`, _routeParams, body);
  }

  public stats(from?: Date, to?: Date) {

    const f = from ? from : moment().subtract(1, 'year').toDate();
    const t = to ? to : new Date();

    return this.get(`${this.endPoint}/stats/?from=${f.toISOString()}&to=${t.toISOString()}`, {});
  }
}
